import React, { Component } from 'react';
import { Menu } from '@progress/kendo-react-layout';
import { Keys } from '@progress/kendo-react-common';
import {
  PUZZLE_MENU_PROPS
} from './Types';
import withVisibility from '../../hoc/withVisibility';

class PuzzleMenu extends Component<PUZZLE_MENU_PROPS> {
  menuRef: any = React.createRef();

  componentDidUpdate(prevProps: Readonly<PUZZLE_MENU_PROPS>) {
    const { isVisible } = this.props;

    if (isVisible && (isVisible !== prevProps.isVisible)) {
      this.focusOnShow();
    }
  }

  private focusOnShow = () => {
    this.menuRef.current?.querySelector('[tabindex]')?.focus();
  };

  private onBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    this.props.onBlur?.(event);
  };

  private onKeyDown = ({ keyCode }: React.KeyboardEvent) => {
    if (keyCode === Keys.esc) {
      this.props.onEsc?.();
    }
  };

  private onSelect = (event: any) => {
    const { syntheticEvent } = event;

    // space will trigger scroll
    if (syntheticEvent.keyCode === Keys.space || syntheticEvent.keyCode === Keys.enter) {
      syntheticEvent.preventDefault();
    }

    this.props.onSelect?.(event);
  };

  render() {
    const {
      children,
      onSelect,
      onBlur,
      onEsc,
      ...props
    } = this.props;

    return (
      <div
        data-cy={'PuzzleMenu'}
        onBlur={this.onBlur}
        onKeyDown={this.onKeyDown}
        ref={this.menuRef}
      >
        <Menu
          {...props}
          onSelect={this.onSelect}
        >
          {children}
        </Menu>
      </div>
    );
  }
}

export default withVisibility(PuzzleMenu);
